exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ptable-select-col {\n  width: 2.5rem;\n}", ""]);

